module.exports = __webpack_public_path__ + "img/wallet.46eefb70.svg";